import React, { useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { Button } from './ui/button';
import { mockData } from '../mock';

export const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = React.useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Olá! Gostaria de mais informações sobre o Recanto Abelhinha.');
    window.open(`https://wa.me/${mockData.school.whatsapp}?text=${message}`, '_blank');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 animate-in fade-in slide-in-from-bottom-4">
      <Button
        onClick={handleWhatsAppClick}
        className="w-16 h-16 rounded-full bg-gradient-to-br from-green-400 to-emerald-500 hover:from-green-500 hover:to-emerald-600 shadow-2xl hover:shadow-green-500/50 hover:scale-110 transition-all group"
      >
        <MessageCircle className="text-white group-hover:scale-110 transition-transform" size={28} />
      </Button>
      
      {/* Pulse Animation */}
      <div className="absolute inset-0 rounded-full bg-green-400 animate-ping opacity-75"></div>
    </div>
  );
};
